<h3-feedback-list
  title="Issues"
  [feedback]="feedback$ | async"
></h3-feedback-list>
